import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/Button/Button';
import styles from './PromotionGuestView.module.css';

/**
 * PromotionGuestView Component
 * Guest view for non-logged-in users explaining promotions
 */
const PromotionGuestView = () => {
  const navigate = useNavigate();

  const handleSignupClick = () => {
    navigate('/login?modalType=auth-signup');
  };

  return (
    <div className={styles.guestContainer}>
      <div className={styles.bannerCard}>
        <div className={styles.bannerGradient}></div>
        
        <div className={styles.bannerImageContainer}>
          <img
            className={styles.bannerImage}
            src="/assets/images/promotions/bonus.png"
            alt="Promotions"
            loading="lazy"
            onError={(e) => {
              e.target.src = '/assets/images/bonus-welcome-banner.webp';
            }}
          />
        </div>
        
        <div className={styles.bannerContent}>
          <h2 className={styles.bannerTitle}>Amazing Promotions</h2>
          <p className={styles.bannerDescription}>
            Get up to 360% deposit bonuses, free bets, and exclusive rewards. 
            Join now to unlock incredible promotions and boost your gaming experience.
          </p>
          
          <div className={styles.bannerAction}>
            <div className={styles.bannerStatus}>
              <span className={styles.statusLabel}>Available promotions</span>
            </div>
            <Button
              variant="primary"
              size="lg"
              onClick={handleSignupClick}
              className={styles.signupButton}
            >
              Signup to claim
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionGuestView;
